import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';

const PageNotFound = () => {
    const [resources, setResources] = useState({});
    const { language } = useParams();

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            break;
        case ("fr" || "FR"):
            break;
        default:
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };


    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <div className="container page-container ps-4 pe-4">
                <div className="text-center">
                        <p className="text text-dark fw-light fs-4 mb-0">
                            Page Not Found
                            <span className="text-not-found ms-2">404</span>
                        </p>
                        <p className="text text-dark fw-light fs-6">
                            the current route doesn't exist
                            <span className="text-not-found">.</span>
                        </p>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;